module.exports = __webpack_public_path__ + "img/searchBlack.fa2da4e6.png";